import { render, staticRenderFns } from "./cpt-button-option.vue?vue&type=template&id=85e30554&scoped=true"
import script from "./cpt-button-option.vue?vue&type=script&lang=js"
export * from "./cpt-button-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e30554",
  null
  
)

export default component.exports